"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueId = exports.getClassName = exports.getDisplayName = exports.getDefaultTid = exports.componentIdUpperCase = exports.componentId = void 0;
const tslib_1 = require("tslib");
const lodash_uniqueid_1 = tslib_1.__importDefault(require("lodash.uniqueid"));
const settings_1 = tslib_1.__importDefault(require("./settings"));
const { prefix } = settings_1.default;
exports.componentId = prefix;
exports.componentIdUpperCase = prefix.toUpperCase();
const getDefaultTid = (componentName) => `${exports.componentId}-${componentName}`;
exports.getDefaultTid = getDefaultTid;
const getDisplayName = (componentName) => `${componentName}${exports.componentIdUpperCase}`;
exports.getDisplayName = getDisplayName;
const getClassName = (componentName, classText) => `${exports.componentId}-${componentName}-${classText}`;
exports.getClassName = getClassName;
const getUniqueId = (idPrefix) => (0, lodash_uniqueid_1.default)(idPrefix);
exports.getUniqueId = getUniqueId;
